import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import Button from './Button';
import { H2 } from '../text';

const UnsupportedPage = ({ goBack }) => {
    return (
        <View style={{ alignItems: 'center', flex: 1, justifyContent: 'center'  }}>
            <H2 style={{ color: '#a61a2b', paddingBottom: 20 }} text='Unfortunately this page is not supported in this environment!' />
            {
                goBack &&
                    <Button 
                        style={{ backgroundColor: '#a61a2b' }}
                        onPress={goBack}
                        text='Go Back'
                        textStyle={{ color: '#fff' }}
                    />
            }
        </View>
    );
};

UnsupportedPage.propTypes = {
    goBack: PropTypes.func
}

export default UnsupportedPage;
